module.exports = __webpack_public_path__ + "static/img/11.88e1a2b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/6/sp/11.png
// module id = cjxh
// module chunks = 0